import React from 'react';

export const Card = ({ className = '', children, ...rest }) => (
  <div className={`rounded-lg border border-border bg-card text-card-foreground shadow-sm ${className}`} {...rest}>
    {children}
  </div>
);

export const CardHeader = ({ className = '', children, ...rest }) => (
  <div className={`flex flex-col gap-1.5 p-5 ${className}`} {...rest}>
    {children}
  </div>
);

export const CardTitle = ({ className = '', children, ...rest }) => (
  <div className={`text-lg font-semibold leading-none tracking-tight ${className}`} {...rest}>
    {children}
  </div>
);

export const CardDescription = ({ className = '', children, ...rest }) => (
  <p className={`text-sm text-muted-foreground ${className}`} {...rest}>
    {children}
  </p>
);

export const CardContent = ({ className = '', children, ...rest }) => (
  <div className={`p-5 pt-0 ${className}`} {...rest}>
    {children}
  </div>
);

export default Card;
